var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactsChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-message-square-detail",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83919",
    "data-name": "Path 83919",
    d: "M25.8,16H20.2A4.2,4.2,0,0,0,16,20.2v9.1a.7.7,0,0,0,.7.7h9.1A4.2,4.2,0,0,0,30,25.8V20.2A4.2,4.2,0,0,0,25.8,16Zm-1.4,9.1H19.5V23.7h4.9Zm2.1-2.8h-7V20.9h7Z",
    fill: "#165cf3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsChatIcon);
export default __webpack_public_path__ + "static/media/contacts-chat-icon.679235853e52b4df401e645021d7f625.svg";
export { ForwardRef as ReactComponent };